/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerGetConversationHistoryQueryResponse, AiAgentV2ControllerGetConversationHistoryPathParams, AiAgentV2ControllerGetConversationHistoryQueryParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerGetConversationHistory";

function getAiAgentV2ControllerGetConversationHistoryUrl(threadId: AiAgentV2ControllerGetConversationHistoryPathParams["threadId"]) {
  const res = { method: 'GET', url: `/api/v1/ai-agent-v2/history/${threadId}` as const }  
  return res
}

/**
 * @description Returns conversation history grouped by question-answer pairs
 * @summary Get conversation history for a thread
 * {@link /api/v1/ai-agent-v2/history/:threadId}
 */
export async function aiAgentV2ControllerGetConversationHistory(threadId: AiAgentV2ControllerGetConversationHistoryPathParams["threadId"], params?: AiAgentV2ControllerGetConversationHistoryQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAiAgentV2ControllerGetConversationHistoryUrl(threadId).url.toString(), params, ... requestConfig })  
  return res.data
}